var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (articlePlaceholder, backgroundImage, isRecommended, mixes, time) {pug_mixins["mix-list-item"] = pug_interp = function(mix, isRecommended){
var block = (this && this.block), attributes = (this && this.attributes) || {};
const userPath = mix.username && '/' + mix.username
const mixPath = mix.id && userPath + '/' + mix.slug
const modifiedAgo = mix.modified_at && time.ago(mix.modified_at)

pug_html = pug_html + "\u003Cli" + (pug.attrs(pug.merge([{"class": "mix-list-item","data-mix-id": pug.escape(mix.id),"data-mix-name": pug.escape(mix.name),"data-mix-slug": pug.escape(mix.slug),"data-mix-owner": pug.escape(mix.username),"data-recommended": pug.escape(isRecommended),"data-mixed": pug.escape(mix.isMixed)},attributes]), true)) + "\u003E\u003Cdiv" + (" class=\"mix-list-item__thumb\""+pug.attr("href", mixPath, true, true)+pug.attr("data-navigate", mixPath, true, true)+pug.attr("style", pug.style(backgroundImage([
        mix.images && mix.images[0],
        articlePlaceholder
      ])), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"mix-list-item__info\"\u003E\u003Ca" + (" class=\"mix-list-item__name\""+pug.attr("href", mixPath, true, true)+pug.attr("data-navigate", mixPath, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = mix.name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
if (!mix.id && isRecommended) {
pug_html = pug_html + "\u003Cdiv class=\"mix-list-item__subtitle\"\u003ESuggested\u003C\u002Fdiv\u003E";
}
else
if (modifiedAgo) {
pug_html = pug_html + "\u003Cdiv class=\"mix-list-item__subtitle\"\u003ELast updated" + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)) + (pug.escape(null == (pug_interp = modifiedAgo) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (mix.visibility === 'private') {
pug_html = pug_html + "\u003Cdiv class=\"mix-list-item__private\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"mix-list-item__actions\"\u003E\u003Ca class=\"minimal mix-follow-button following-button\"\u003E\u003Ci class=\"mdi-navigation-check\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003Cdiv class=\"mix-list-item__spinner\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E";
};
// iterate mixes
;(function(){
  var $$obj = mixes;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var mix = $$obj[pug_index0];
pug_mixins["mix-list-item"](mix, isRecommended);
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var mix = $$obj[pug_index0];
pug_mixins["mix-list-item"](mix, isRecommended);
    }
  }
}).call(this);
}.call(this,"articlePlaceholder" in locals_for_with?locals_for_with.articlePlaceholder:typeof articlePlaceholder!=="undefined"?articlePlaceholder:undefined,"backgroundImage" in locals_for_with?locals_for_with.backgroundImage:typeof backgroundImage!=="undefined"?backgroundImage:undefined,"isRecommended" in locals_for_with?locals_for_with.isRecommended:typeof isRecommended!=="undefined"?isRecommended:undefined,"mixes" in locals_for_with?locals_for_with.mixes:typeof mixes!=="undefined"?mixes:undefined,"time" in locals_for_with?locals_for_with.time:typeof time!=="undefined"?time:undefined));;return pug_html;};
module.exports = template;